module.exports = __webpack_public_path__ + "img/Terrene_logo.04829733.png";